import { getSdk } from '../utils/sdk'

export const getCybersourceCaptureContext = () => {
  return getSdk().getCybersourceCaptureContext()
}
